import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { CheckCircle2, Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(Number(n) || 0);

export default function PublicQuoteSuccess() {
  const { token } = useParams();
  const [status, setStatus] = useState(null);
  const [polling, setPolling] = useState(true);

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API_BASE}/public/quotes/${token}/status`);
        setStatus(data);
        if (data.payment_status === "paid" || attempts >= 8) {
          setPolling(false);
          return;
        }
      } catch (_) {
        if (attempts >= 8) {
          setPolling(false);
          return;
        }
      }
      setTimeout(poll, 1500);
    };
    poll();
  }, [token]);

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4">
      <Card className="rounded-sm max-w-md w-full p-8 border-emerald-200 bg-white" data-testid="public-quote-success">
        <div className="flex items-center gap-3 mb-5">
          <BrandLogo className="h-9 w-9" />
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500">Wineemotion Assistenza</div>
            <div className="font-display font-semibold text-zinc-950">Grazie per il pagamento</div>
          </div>
        </div>
        {polling && (
          <div className="flex items-center gap-3 text-sm text-zinc-600">
            <Loader2 className="h-4 w-4 animate-spin" /> Stiamo confermando il pagamento con Stripe...
          </div>
        )}
        {!polling && status?.payment_status === "paid" && (
          <div className="space-y-3">
            <div className="flex items-center gap-3 text-emerald-700">
              <CheckCircle2 className="h-6 w-6" />
              <div className="font-semibold">Pagamento ricevuto</div>
            </div>
            <div className="text-sm text-zinc-700">
              Il preventivo <b>{status.quote_number}</b> risulta saldato per un importo di <b>{fmt(status.total)}</b>.
              Riceverà a breve conferma dal nostro team.
            </div>
          </div>
        )}
        {!polling && status?.payment_status !== "paid" && (
          <div className="text-sm text-zinc-700">
            Il pagamento è in elaborazione. Riceverà una conferma via email non appena verrà validato dal circuito bancario.
          </div>
        )}
      </Card>
    </div>
  );
}
